/* eslint-disable react/prop-types */
/*
Author: Nishant Singh
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';

import CustomerClusterScreen from '@/screens/setting/customer-cluster/CustomerClusterScreen';
import CustomerClusterDetailScreen from '@/screens/setting/customer-cluster/CustomerClusterDetailScreen';
import CustomerClusterFormScreen from '@/screens/setting/customer-cluster/CustomerClusterFormScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const CustomerClusterNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="CustomerClusterScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="CustomerClusterScreen"
        component={CustomerClusterScreen}
        options={() => ({
          // headerRight (incl. the mobile Add) is owned by CustomerClusterScreen
          // so Add goes through openChild and preserves the list on return.
          title: setTitleHeader('Customer Cluster'),
        })}
      />
      <Stack.Screen
        name="CustomerClusterDetailScreen"
        component={CustomerClusterDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Customer Cluster';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                isJump={true}
                customBack={{ screen: 'CustomerClusterScreen' }}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
      <Stack.Screen
        name="CustomerClusterFormScreen"
        component={CustomerClusterFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Create Customer Cluster';
          let params = {};
          let isEdit = false;
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
            params = route.params;
            isEdit = true;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                isJump={true}
                customBack={{
                  screen: isEdit
                    ? 'CustomerClusterDetailScreen'
                    : 'CustomerClusterScreen',
                  params: params,
                }}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default CustomerClusterNavigator;
